import { render } from "./BrowserNotSupported.vue?vue&type=template&id=c18debaa"
import script from "./BrowserNotSupported.vue?vue&type=script&lang=js"
export * from "./BrowserNotSupported.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__